import React, { useState } from 'react';
import axios from 'axios';
import API_BASE_URL from "../config";
import '../css/educationForm.css';

const EducationForm = ({ onBack, onNext }) => {
  const [formData, setFormData] = useState({
    highest_qualification: '',
    institution_name: '',
    year_of_graduation: '',
    company_name: '',
    job_title: '',
    start_year: '',
    end_year: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API_BASE_URL}/education-info`, formData, { withCredentials: true });
      onNext();
    } catch (err) {
      console.error('Error submitting education info:', err);
    }
  };

  return (
    <form className="education-form-container" onSubmit={handleSubmit} autoComplete="off">
      <h3>Education Details</h3>
      <div className="education-group">
        <input name="highest_qualification" type="text" placeholder="Highest Qualification" onChange={handleChange} />
        <input name="institution_name" type="text" placeholder="University/College" onChange={handleChange} />
        <input name="year_of_graduation" type="text" placeholder="Year of Graduation" onChange={handleChange} />
      </div>

      <h3>Work Experience</h3>
      <div className="work-group">
        <input name="company_name" type="text" placeholder="Company Name" onChange={handleChange} />
        <input name="job_title" type="text" placeholder="Job Title" onChange={handleChange} />
        <input name="start_year" type="text" placeholder="Start year" onChange={handleChange} />
        <input name="end_year" type="text" placeholder="End year" onChange={handleChange} />
      </div>

      <div className="button-group">
        <button type="button" className="back" onClick={onBack}>Back</button>
        <button type="submit" className="next">Next</button>
      </div>
    </form>
  );
};

export default EducationForm;
